{
  "$schema": "https://zam.app/schemas/v1/kvt-tile.json",
  "tile_id": "de-by:realschule-7-geographie-europa-raum-wirtschaft",
  "version": "2026.08.1",
  "title": "Geographie 7: Europa – Großlandschaften, Klima und Alpenraum (Realschule 7 Bayern)",
  "description": "Geerdetes KVT-Paket für Realschule Bayern Geographie 7: Großlandschaften Europas, Klimazonen (maritim vs. kontinental), Alpenentstehung/Vegetationsstufen und Europäische Union.",
  "publisher": "ZAM Curriculum Working Group",
  "published_at": "2026-08-15T22:45:00Z",
  "sources": [
    {
      "uri": "https://www.lehrplanplus.bayern.de/fachlehrplan/realschule/7/geographie",
      "checked": "2026-08-15",
      "label": "Realschule Geographie 7, Lernbereich Räume und Strukturen in Europa"
    }
  ],
  "atoms": [
    {
      "id": "01K4G7E0000000000000000A01",
      "atom_uri": "urn:zam:atom:01K4G7E0000000000000000A01",
      "namespace": "geographie-europa",
      "slug": "grosslandschaften-europas-relief-gliederung",
      "title": "Die Großlandschaften Europas: Tiefland, Mittelgebirge, Hochgebirge und Küsten",
      "domain": "schule/geographie/europa",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q1071",
          "target_label": "Geography of Europe",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "geographie",
          "topic_code": "lb1",
          "topic_title": "Europa – Vielfalt der Landschaften",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "geographie",
          "topic_code": "lb1",
          "topic_title": "Europa – Vielfalt der Landschaften",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4G7E0000000000000000J01",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welches mächtige Hochgebirge bildet die natürliche Grenze zwischen Europa und Asien im Osten?",
          "concept": "Das Uralgebirge (Ural)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Das Uralgebirge",
              "Die Alpen"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4G7E0000000000000000J02",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Gliedere den europäischen Kontinent in seine vier morphologischen Großlandschaftszonen von Nord nach Süd (Nordeuropäisches Tiefland/Schilde, Mittelgebirgszone, Faltengebirgszone der jungen Hochgebirge wie Alpen/Pyrenäen/Karpaten, Südeuropäischer Mittelmeerraum mit Halbinseln) und beschreibe die glaziale Prägung des Nordeuropäischen Tieflands durch die pleistozänen Eiszeiten (Moränen, Urstromtäler, Seenplatten).",
          "concept": "4 Großlandschaften: 1. Baltischer Schild & Nordeuropäisches Tiefland (flach, glazial geprägt: Grundmoräne, Endmoräne, Sander, Urstromtäler, Seen), 2. Mittelgebirgsschwelle (Rumpfgebirge aus paläozoischer Faltung: Harz, Rheinisches Schiefergebirge, Bayerischer Wald), 3. Junge alpidische Faltengebirge (Alpen, Pyrenäen, Karpaten, Apennin - schroffe Formen, Vergletscherung), 4. Mittelmeerraum (Iberische, Apennin-, Balkanhalbinsel, vulkanisch aktiv).",
          "sample_solution": "1. Die vier Großlandschaftszonen Europas: - Nordeuropäisches Tiefland und Fennoskandischer Schild: Reicht von den Niederlanden über Norddeutschland und Polen bis zum Ural. Flaches bis sanft hügeliges Relief mit Höhen selten über 200 m über NN. - Europäische Mittelgebirgszone: Zieht sich quer durch Mitteleuropa (z. B. Rheinisches Schiefergebirge, Harz, Thüringer Wald, Bayerischer Wald, Erzgebirge, Französisches Zentralmassiv). Alte, abgerundete Rumpfgebirge (variszische Gebirgsbildung vor ~300 Mio. Jahren), reich an Erzen und Kohle. - Alpidische Hochgebirgszone (Junge Faltengebirge): Alpen (Mont Blanc 4810 m), Pyrenäen, Karpaten, Apennin, Dinariden und Kaukasus. Entstanden in der Tertiärzeit durch die Kollision der afrikanischen mit der eurasischen Kontinentalplatte; steile Felsgipfel, schroffe Grate, tiefe Kerbtäler und rezente Gletscher. - Südeuropäischer Mittelmeerraum: Gekennzeichnet durch die drei großen Halbinseln (Iberische, Italienische und Balkan-Halbinsel) mit starker tektonischer und vulkanischer Aktivität (Vesuv, Ätna) und Karstlandschaften. 2. Glaziale Prägung des Tieflands (Glaziale Serie): - In den Kaltzeiten des Pleistozäns schoben sich riesige Inlandeismassen aus Skandinavien bis nach Mitteleuropa vor. - Glaziale Serie (von Norden nach Süden):   * Grundmoräne: Flachwellige Lehm- und Geschiebemergellandschaft mit vielen Seen (z. B. Mecklenburgische Seenplatte).   * Endmoränenwall: Schuttwälle, die der Gletscher an seiner maximalen Stillstandslinie aufschüttete.   * Sander: Sandige, unfruchtbare Schwemmfächer des Schmelzwassers.   * Urstromtäler: Breite, muldenförmige Abflussrinnen für das nach Nordwesten zum Meer strömende Schmelzwasser (z. B. Elbe-, Oder-Urstromtal)."
        }
      ]
    },
    {
      "id": "01K4G7E0000000000000000A02",
      "atom_uri": "urn:zam:atom:01K4G7E0000000000000000A02",
      "namespace": "geographie-europa",
      "slug": "klimazonen-maritim-vs-kontinental-klimadiagramme",
      "title": "Klimazonen Europas: Maritimes vs. kontinentales Klima und Klimadiagramm-Analyse",
      "domain": "schule/geographie/europa",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [
        {
          "atom_id": "01K4G7E0000000000000000A01",
          "type": "hard",
          "rationale": "Relief und Lage zum Ozean bestimmen das europäische Klimamuster."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q1071",
          "target_label": "Climate of Europe",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "geographie",
          "topic_code": "lb1",
          "topic_title": "Europa – Vielfalt der Landschaften",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "geographie",
          "topic_code": "lb1",
          "topic_title": "Europa – Vielfalt der Landschaften",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4G7E0000000000000000J03",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welche Meeresströmung wirkt wie eine 'Warmwasserheizung' und sorgt für mildes, frostarmes Klima an den Küsten West- und Nordwesteuropas?",
          "concept": "Der Nordatlantikstrom (Golfstrom-System)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Der Nordatlantikstrom (Golfstrom)",
              "Der Humboldtstrom"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4G7E0000000000000000J04",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Vergleiche das maritime (ozeanische) Klima Westeuropas (Irland/Großbritannien) mit dem kontinentalen Klima Osteuropas (Polen/Russland) anhand von Jahrestemperaturschwankung (Amplitude), Sommer-/Wintertemperaturen und Niederschlagsverteilung und erkläre die Auswertung eines Klimadiagramms nach Walter/Lieth (humide vs. aride Monate).",
          "concept": "Maritim: geringe Temperaturamplitude (<15K), milde Winter, mäßig warme Sommer, ganzjährig hohe Niederschläge (Westwindzone); Kontinental: große Amplitude (>25K), heiße Sommer, eisige/frostige Winter, Niederschlagsmaximum im Sommer; Klimadiagramm nach Walter/Lieth: Maßstab 10 °C entspricht 20 mm Niederschlag; Niederschlagskurve über Temperaturkurve -> humid (feucht); Temperaturkurve über Niederschlag -> arid (trocken).",
          "sample_solution": "1. Maritimes vs. Kontinentales Klima in Europa: - Maritimes (ozeanisches) Klima (Westeuropa, z. B. Dublin, Brest):   * Ursache: Ständiger Einfluss feucht-milder Luftmassen vom Atlantik und der wärmenden Wirkung des Nordatlantikstroms (Golfstrom).   * Temperaturen: Sehr geringe Jahresschwankung (Temperaturamplitude < 12–15 °C). Milde, meist frostfreie Winter und mäßig warme Sommer.   * Niederschläge: Ganzjährig sehr ergiebig (800–1500 mm), oft als Dauer- und Nieselregen mit Maximum im Herbst/Winter. - Kontinentales Klima (Osteuropa, z. B. Moskau, Kiew):   * Ursache: Weite Entfernung zum Atlantik (Landmasse kühlt im Winter extrem aus und heizt sich im Sommer stark auf; 'Kontinentalitätseffekt').   * Temperaturen: Sehr hohe Jahrestemperaturamplitude (> 25–35 °C). Heiße Sommer (> 22 °C) und extrem kalte, schneereiche Frostwinter mit Dauerfrost (< -10 °C).   * Niederschläge: Geringe bis mäßige Jahresmenge (400–600 mm) mit deutlichem Niederschlagsmaximum im Sommer (konvektive Gewitterschauer). - Mittelmeerklima (Südeuropa): Heiße, trockene Sommer (Subtropenhoch/Dürre) und milde, feuchte Winter (Zyklonenzug). 2. Auswertung eines Klimadiagramms nach Walter/Lieth: - Konstruktion: Temperaturachse (rechts/links, 10 °C-Schritte) und Niederschlagsachse im festen Verhältnis 1 : 2 (10 °C entsprechen 20 mm Niederschlag). - Humide Phase (feucht): Liegt die blaue Niederschlagskurve oberhalb der roten Temperaturkurve, übersteigt das Wasserangebot die Verdunstung -> optimales Pflanzenwachstum (blaue Schraffur). - Aride Phase (Trockenzeit / Dürre): Liegt die Temperaturkurve über der Niederschlagskurve, verdunstet mehr Wasser als regnet -> Wassermangel/Trockenstress für die Vegetation (gelbe Punktierung)."
        }
      ]
    },
    {
      "id": "01K4G7E0000000000000000A03",
      "atom_uri": "urn:zam:atom:01K4G7E0000000000000000A03",
      "namespace": "geographie-europa",
      "slug": "alpenraum-tektonik-vegetationsstufen-tourismus",
      "title": "Der Alpenraum: Entstehung, Höhenstufen der Vegetation und Nutzungskonflikte",
      "domain": "schule/geographie/europa",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [
        {
          "atom_id": "01K4G7E0000000000000000A01",
          "type": "hard",
          "rationale": "Hochgebirgsrelief ist Basis für Höhenstufen und alpine Gefahren."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q1071",
          "target_label": "Alps",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "geographie",
          "topic_code": "lb2",
          "topic_title": "Der Alpenraum",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "geographie",
          "topic_code": "lb2",
          "topic_title": "Der Alpenraum",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4G7E0000000000000000J05",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Um wie viel Grad Celsius sinkt die Lufttemperatur in den Alpen im statistischen Mittel pro 100 Höhenmeter Höhenanstieg?",
          "concept": "Um ca. 0,6 °C (bis 0,7 °C) pro 100 Meter Höhenunterschied (vertikaler Temperaturgradient)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Um ca. 0,6 °C pro 100 m",
              "Um ca. 3,0 °C pro 100 m"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4G7E0000000000000000J06",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Beschreibe die Höhenstufen der Vegetation in den Alpen von unten nach oben (Talstufe/Kollin: Laubwald/Ackerbau, Montan: Bergmischwald, Subalpin: Nadelwald/Fichte/Lärche bis zur Baumgrenze, Alpin: Zwergstrauchheide & Almmatten bis zur Schneegrenze, Nival: Fels/Eis/Gletscher) und analysiere die ökologischen Nutzungskonflikte zwischen Massentourismus (Schneekanonen, Pistenrodung, Verkehrslärm) und dem Schutz vor Naturgefahren (Lawinen, Muren, Bergstürze, Bannwaldschutz).",
          "concept": "Höhenstufen: Kollin (Laubwald/Grünland) -> Montan (Buchen/Tannen-Mischwald) -> Subalpin (Fichten/Lärchen/Arven bis Baumgrenze ~1800-2000m) -> Alpin (Krummholz/Almweiden bis Schneegrenze ~2800m) -> Nival (Gletscher/ewiges Eis); Konflikte: Skitourismus zerstört Schutzwald, Planierung erzeugt Erosionsflächen, künstliche Beschneiung verbraucht enorme Wasser-/Strommengen; Schutzwald schützt Täler vor Lawinen und Murenabgängen.",
          "sample_solution": "1. Höhenstufen der Vegetation in den Alpen: Durch den vertikalen Temperaturrückgang um ca. 0,6 °C pro 100 m Höhe verändern sich Klima und Pflanzenwelt stockwerkartig von unten nach oben: - Kolline / Planare Stufe (Talstufe bis ~800 m): Laubwald (Eichen, Buchen), intensiver Ackerbau und Obstbau. - Montane Stufe (Bergwaldstufe bis ~1500 m): Bergmischwald (Buche, Tanne, Fichte). Wichtiger Schutzwald für darunterliegende Siedlungen. - Subalpine Stufe (bis ~1800–2100 m): Reiner Nadelwald (Fichten, Lärchen, Zirben) bis zur **Wald- und Baumgrenze** (wo die Vegetationsperiode unter 100 Tage sinkt). - Alpine Stufe (Mattenstufe bis ~2600–2800 m): Baumlos; Krummholz (Latschenkiefer, Alpenrose), alpine Rasen/Almwiesen mit Enzian und Edelweiß. Nutzung als sommerliche Viehweide (Almwirtschaft). - Nivale Stufe (Schneestufe ab der klimatischen Schneegrenze bei ~2800–3000 m): Ganzjährige Schnee- und Eisbedeckung (Gletscher), nackter Fels, nur noch Flechten und Moos. 2. Alpine Naturgefahren und Nutzungskonflikte: - Naturgefahren: Schneebretter und Lawinen im Winter; Murenabgänge (Schlamm- und Gerölllawinen), Hangrutschungen und Steinschläge bei Starkregen oder Auftauen des Permafrosts. - Der Schutzwald (Bannwald): Wirkt als natürliches Schutzschild. Die Bäume bremsen Schneemassen, stabilisieren mit ihren Wurzeln den Berghang und saugen Regenwasser auf. - Konflikte mit dem Massentourismus:   * Pistenbau & Rodung: Schlägerungen zerstören den Schutzwald; Bodenverdichtung durch Pistenraupen verringert die Versickerungsfähigkeit des Bodens -> massiv erhöhtes Muren- und Erosionsrisiko.   * Künstliche Beschneiung (Schneekanonen): Extrem hoher Wasser- und Energieverbrauch; Entnahme aus Gebirgsbächen gefährdet das Ökosystem.   * Transitverkehr: Schadstoffe und Lärmbelastung in engen Tälern (Brenner-Achse, Inntal)."
        }
      ]
    },
    {
      "id": "01K4G7E0000000000000000A04",
      "atom_uri": "urn:zam:atom:01K4G7E0000000000000000A04",
      "namespace": "geographie-europa",
      "slug": "europaeische-union-binnenmarkt-vier-freiheiten",
      "title": "Die Europäische Union: Der Europäische Binnenmarkt und die vier Grundfreiheiten",
      "domain": "schule/geographie/europa",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [
        {
          "atom_id": "01K4G7E0000000000000000A01",
          "type": "hard",
          "rationale": "Länderkenntnis und politische Geographie Europas bilden die Basis für die EU."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q1071",
          "target_label": "European Single Market",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "geographie",
          "topic_code": "lb3",
          "topic_title": "Europa im Wandel – Zusammenarbeit in der EU",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "geographie",
          "topic_code": "lb3",
          "topic_title": "Europa im Wandel – Zusammenarbeit in der EU",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4G7E0000000000000000J07",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welches Abkommen ermöglichte den weitgehenden Wegfall der stationären Personenkontrollen an den Binnengrenzen der meisten europäischen Staaten?",
          "concept": "Das Schengener Abkommen (Schengen-Raum)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Das Schengener Abkommen (Schengen-Raum)",
              "Der Vertrag von Maastricht"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4G7E0000000000000000J08",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erläutere die Entstehung und Zielsetzung der Europäischen Union (Friedenssicherung, wirtschaftlicher Wohlstand, supranationale Wertegemeinschaft), definiere die 'vier Grundfreiheiten' des Europäischen Binnenmarkts (Freier Warenverkehr, Freier Personenverkehr, Freier Dienstleistungsverkehr, Freier Kapitalverkehr) und nenne Vor- und Nachteile der gemeinsamen Währung Euro für Bürger und Unternehmen.",
          "concept": "EU = Friedens- und Wertebündnis, gewachsen aus Montanunion (1951) und Römischen Verträgen (1957 EWG); 4 Freiheiten: 1. Waren (keine Zölle), 2. Personen (freie Wohnort-/Arbeitsplatzwahl, Schengen), 3. Dienstleistungen (grenzüberschreitende Angebote), 4. Kapital (Investitionen im EU-Ausland ohne Devisenbeschränkung); Euro-Vorteile: kein Geldwechseln, Preistransparenz, Wegfall von Wechselkursrisiken; Nachteile: einheitliche Geldpolitik (EZB) passt nicht gleichermaßen für boomende und kriselnde Volkswirtschaften.",
          "sample_solution": "1. Idee und Entwicklung der Europäischen Union (EU): - Entstanden aus der historischen Lehre des Zweiten Weltkriegs als beispielloses Friedens- und Integrationsprojekt zur dauerhaften Aussöhnung in Europa. - Entwicklungsschritte: EGKS / Montanunion (1951: Vergemeinschaftung von Kohle und Stahl zwischen Deutschland, Frankreich, Italien und Benelux) -> EWG / Römische Verträge (1957) -> Vertrag von Maastricht (1992 Gründung der EU mit Unionsbürgerschaft und Wirtschafts- und Währungsunion). 2. Die vier Grundfreiheiten des EU-Binnenmarktes: - 1. Freier Warenverkehr: Vollständiger Abbau aller Zölle und mengenmäßigen Einfuhrbeschränkungen zwischen Mitgliedstaaten; einheitliche Produktstandards und CE-Kennzeichnung. - 2. Freier Personenverkehr (Schengener Abkommen): EU-Bürger dürfen ohne Visum und Passkontrollen in jeden anderen Mitgliedsstaat reisen, dort studieren, wohnen und jeden Beruf ergreifen (Niederlassungs- und Arbeitnehmerfreizügigkeit). - 3. Freier Dienstleistungsverkehr: Unternehmen und Freiberufler (z. B. Handwerker, IT-Berater, Banken) dürfen ihre Dienste uneingeschränkt im gesamten EU-Gebiet anbieten. - 4. Freier Kapitalverkehr: Geld- und Finanzmittel können ohne Beschränkungen oder Sonderabgaben grenzüberschreitend überwiesen, angelegt oder in ausländische Immobilien und Firmen investiert werden. 3. Der Euro und die Eurozone: - Vorteile für Bürger und Wirtschaft: Kein lästiger und kostspieliger Geldwechsel auf Reisen; absolute Preistransparenz und Vergleichbarkeit von Konsumgütern; Wegfall von Wechselkursschwankungen und Währungsrisiken für den Außenhandel (wichtiger Exportvorteil für Deutschland). - Herausforderungen: Nationale Zentralbanken gaben ihre Währungshoheit an die Europäische Zentralbank (EZB) ab; einheitlicher Leitzins muss für strukturell sehr unterschiedliche Volkswirtschaften passen."
        }
      ]
    }
  ]
}
